module.exports = __webpack_public_path__ + "static/media/illustration.b67b6b17.svg";